export const CAROUSEL_HEADER_PADDING = 16;
export const CAROUSEL_PRODUCT_CARD_TEST_ID = 'carousel-product-card-anchor';
